import React from 'react';
import PropTypes from 'prop-types';
import { Button, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NavBarButton = ({ path, label, Icon, isActive, variant, onClick, collapsed = false, singleLine = false, sx }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(path);
    }
  };

  return (
    <Button
      className={isActive ? 'active' : ''}
      onClick={handleClick}
      fullWidth
      color={isActive ? 'primary' : variant === 'filled' ? 'primary' : 'inherit'}
      sx={{
        backgroundColor: variant === 'filled' ? 'primary.main' : 'transparent',
        padding: collapsed ? '12px 0' : '12px 16px',
        position: 'relative',
        overflow: 'hidden',
        justifyContent: 'center',
        mb: 1,
        minWidth: collapsed ? '40px' : 'auto',
        '&:hover': {
          backgroundColor: variant === 'filled' ? 'primary.dark' : 'action.hover',
        },
        ...sx,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          justifyContent: collapsed ? 'center' : 'flex-start',
          color: variant === 'filled' ? '#fff' : 'inherit',
        }}
      >
        {Icon && (
          <Box
            sx={{
              mr: collapsed ? 0 : 2,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Icon color="inherit" />
          </Box>
        )}
        {!collapsed && (
          <Typography
            sx={{
              color: variant === 'filled' ? '#fff' : 'inherit',
              fontWeight: isActive ? 600 : 400,
              display: 'flex',
              alignItems: 'center',
              whiteSpace: singleLine ? 'nowrap' : 'normal',
              overflow: singleLine ? 'hidden' : 'visible',
              textOverflow: singleLine ? 'ellipsis' : 'clip',
            }}
          >
            {label}
          </Typography>
        )}
      </Box>
    </Button>
  );
};

NavBarButton.propTypes = {
  path: PropTypes.string,
  label: PropTypes.string.isRequired,
  Icon: PropTypes.elementType,
  isActive: PropTypes.bool,
  variant: PropTypes.string,
  onClick: PropTypes.func,
  collapsed: PropTypes.bool,
  singleLine: PropTypes.bool,
  sx: PropTypes.object,
};

export default NavBarButton;
